import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";

interface DataPoint {
  date?: string;
  day?: string;
  count: number;
}

interface Props {
  data: DataPoint[];
  color?: string;
  height?: number;
  label?: string;
}

const LinksLineChart: React.FC<Props> = ({
  data,
  color = "#0058A9",
  height = 200,
  label,
}) => {
  const mapped = data.map((d) => ({
    date: d.date ?? d.day ?? "",
    count: d.count,
  }));

  return (
    <Wrapper>
      {label && <ChartLabel>{label}</ChartLabel>}
      <ResponsiveContainer width="100%" height={height}>
        <LineChart data={mapped} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 10, fill: "#888" }}
            tickFormatter={(v: string) => v.slice(5)}
          />
          <YAxis tick={{ fontSize: 10, fill: "#888" }} allowDecimals={false} />
          <Tooltip
            formatter={(value) => [value ?? 0, "Links"]}
            labelFormatter={(label) => `Date: ${label}`}
          />
          <Line
            type="monotone"
            dataKey="count"
            stroke={color}
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Wrapper>
  );
};

export default LinksLineChart;

const Wrapper = styled.div`
  width: 100%;
`;

const ChartLabel = styled.p`
  font-size: 12px;
  color: #666;
  margin: 0 0 6px;
  font-weight: 600;
`;
